import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.scss";
import { AppContext } from "../context";
import {
  claimRoute,
  gminatorRoute,
  leaderboardRoute,
  marketplaceRoute,
} from "../index";
import { removeSlash } from "../utils/String";

const getButtonText = (walletToDisplay?: string): string => {
  if (!walletToDisplay) {
    return "connect wallet";
  }
  return walletToDisplay.length <= 14
    ? walletToDisplay
    : `${walletToDisplay.substring(0, 3)}...${walletToDisplay.substring(
        walletToDisplay.length - 5
      )}`;
};

const Navbar = () => {
  const [isActive, setIsActive] = useState(false);
  const { connect, wallet, walletName } = useContext(AppContext);
  const connected = !!wallet;
  const walletToDisplay = walletName || wallet;
  const buttonText = getButtonText(walletToDisplay);

  const toggleBurgerMenu = () => {
    setIsActive(!isActive);
  };

  return (
    <nav
      className="navbar is-fixed is-transparent"
      role="navigation"
      aria-label="main navigation"
      id="navbar"
    >
      <div className="navbar-brand">
        <Link className="navbar-item rg-logo" to="/">
          Reply Guys
        </Link>

        <div
          role="button"
          className={`navbar-burger ${isActive ? "is-active" : ""}`}
          aria-label="menu"
          aria-expanded="false"
          onClick={toggleBurgerMenu}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </div>
      </div>

      <div className={`navbar-menu ${isActive ? "is-active" : ""}`}>
        <div className="navbar-start">
          {/* <Link to="/cyberkongz" className="navbar-item">
            Banana burn
          </Link> */}
          <Link to={leaderboardRoute.path} className="navbar-item">
            {removeSlash(leaderboardRoute.path)}
          </Link>
          <Link to={claimRoute.path} className="navbar-item">
            {removeSlash(claimRoute.path)}
          </Link>
          <Link to={gminatorRoute.path} className="navbar-item">
            {removeSlash(gminatorRoute.path)}
          </Link>
          <Link to={marketplaceRoute.path} className="navbar-item">
            {removeSlash(marketplaceRoute.path)}
          </Link>
        </div>

        <div className="navbar-end">
          <div className="navbar-item">
            <div className="buttons">
              <button
                className={`connect-button button ${
                  connected ? "connected" : ""
                }`}
                onClick={connect}
                id="connectButton"
              >
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
